import React from 'react';
import './SortItem.css';

export function SortItem({sort = '', sortd, title, className, onChange}) {

  const handleChangeSort = () => {
    if (!sortd || sortd === 'desc') {
      onChange(sort, 'asc');
    } else {
      onChange(sort, 'desc');
    }
  };

  return <div className={"sort__item " + (className ? " " + className : "")}>
    <span>{title}</span>
    {sort !== '' && <span className={"sort__icon" + (sortd ? " sort__icon--" + sortd : "")} onClick={handleChangeSort}></span>}
  </div>;
}
